import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../../css/styles.css';

const MotionDiv = motion.div;
const MotionA = motion.a;
// Fix: Replace motion(Link) with motion.div wrapping Link for compatibility
const MotionLink = motion.create ? motion.create(Link) : motion.div;

const Footer = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <footer className="modern-footer">
      <MotionDiv 
        className="footer-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-grid">
            {/* Brand Section */}
            <MotionDiv className="footer-brand" variants={itemVariants}>
              <Link className="footer-logo" to="/">
                <span className="brand-text">POSlah!</span>
              </Link>
              <p className="footer-description">
                Transform your hawker stall with AI-powered POS technology. 
                Boost sales, streamline operations, and serve customers faster.
              </p>
              <div className="social-links">
                <MotionA 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <i className="bi bi-facebook"></i>
                </MotionA>
                <MotionA 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <i className="bi bi-instagram"></i>
                </MotionA>
                <MotionA 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <i className="bi bi-twitter-x"></i>
                </MotionA>
                <MotionA 
                  href="https://github.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <i className="bi bi-github"></i>
                </MotionA>
              </div>
            </MotionDiv>

            {/* Product Links */}
            <MotionDiv className="footer-section" variants={itemVariants}>
              <h3 className="footer-heading">Product</h3>
              <ul className="footer-links">
                <li><Link to="/#features">Features</Link></li>
                <li><Link to="/#pricing">Pricing</Link></li>
                <li><Link to="/#reviews">Reviews</Link></li>
                <li><Link to="/getstarted">Get Started</Link></li>
              </ul>
            </MotionDiv>

            {/* Company Links */}
            <MotionDiv className="footer-section" variants={itemVariants}>
              <h3 className="footer-heading">Company</h3>
              <ul className="footer-links">
                <li><a href="/about">About Us</a></li>
                <li><a href="/careers">Careers</a></li>
                <li><a href="/blog">Blog</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </MotionDiv>

            {/* Support Links */}
            <MotionDiv className="footer-section" variants={itemVariants}>
              <h3 className="footer-heading">Support</h3>
              <ul className="footer-links">
                <li><a href="/help">Help Center</a></li>
                <li><a href="/documentation">Documentation</a></li>
                <li><a href="/api">API Reference</a></li>
                <li><a href="/status">System Status</a></li>
              </ul>
            </MotionDiv>

            {/* Legal Links */}
            <MotionDiv className="footer-section" variants={itemVariants}>
              <h3 className="footer-heading">Legal</h3>
              <ul className="footer-links">
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/terms">Terms of Service</a></li>
                <li><a href="/cookies">Cookie Policy</a></li>
                <li><a href="/compliance">Compliance</a></li>
              </ul>
            </MotionDiv>
          </div>
        </div>

        {/* CTA Section */}
        <MotionDiv className="footer-cta" variants={itemVariants}>
          <div className="cta-content">
            <h3>Ready to transform your hawker business?</h3>
            <p>Join thousands of hawkers already using POSlah!</p>
            {/* Fixed: Conditional rendering for MotionLink */}
            {motion.create ? (
              <MotionLink 
                className="request-demo-btn"
                to="/request-demo"
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                Request A Demo
              </MotionLink>
            ) : (
              <MotionDiv
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link 
                  className="request-demo-btn"
                  to="/request-demo"
                >
                  Request A Demo
                </Link>
              </MotionDiv>
            )}
          </div>
        </MotionDiv>

        {/* Footer Bottom */}
        <MotionDiv className="footer-bottom" variants={itemVariants}>
          <div className="footer-bottom-content">
            <p className="copyright">©2025 POSlah! Pte Ltd, owned by SLR. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="/sitemap">Sitemap</a>
              <a href="/accessibility">Accessibility</a>
            </div>
          </div>
        </MotionDiv>
      </MotionDiv>
    </footer>
  );
};

export default Footer;